import { buffers, END, eventChannel } from 'redux-saga';
import { getXHRResponseHeaders, HttpMethodType, HttpStatusCode, MimeTypeService, XhrReadyState } from "../../../common";
import { FileUploadStatus } from '../../enums';
export function createUploadFileChannel(endpoint, file, 
/*istanbul ignore next*/
xhr = new XMLHttpRequest()) {
    return eventChannel(emitter => {
        //shouldEmitProgress flag helps to reduce progress notification count to approx. half
        let shouldEmitProgress = true;
        const onProgress = (e) => {
            if (e.lengthComputable) {
                const progress = (e.loaded / e.total) * 100;
                if (shouldEmitProgress || progress === 100) {
                    emitter({ progress, status: FileUploadStatus.IN_PROGRESS });
                    shouldEmitProgress = false;
                }
                else {
                    shouldEmitProgress = true;
                }
            }
        };
        const onFailure = () => {
            emitter({ status: FileUploadStatus.FAILED });
            emitter(END);
        };
        xhr.upload.addEventListener('progress', onProgress);
        xhr.upload.addEventListener('error', onFailure);
        xhr.onreadystatechange = () => {
            const { readyState, status } = xhr;
            if (readyState === XhrReadyState.DONE) {
                const fileUploadStatus = status === HttpStatusCode.OK || status === HttpStatusCode.Created
                    ? FileUploadStatus.SUCCESS
                    : FileUploadStatus.FAILED;
                emitter({ status: fileUploadStatus, headers: getXHRResponseHeaders(xhr) });
                emitter(END);
            }
        };
        const fileName = file.name;
        const contentTypeValue = MimeTypeService.lookup(fileName);
        xhr.open(HttpMethodType.PUT, endpoint, true);
        xhr.setRequestHeader('Content-Type', contentTypeValue);
        xhr.send(file);
        return () => {
            xhr.upload.removeEventListener('progress', onProgress);
            xhr.upload.removeEventListener('error', onFailure);
            xhr.onreadystatechange = null;
            xhr.upload.onprogress = null;
            xhr.abort();
        };
    }, buffers.sliding(2));
}
//# sourceMappingURL=createUploadChannel.js.map